import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormToggle } from '@ami/react/core';
import { Quote } from '../../quote';
import { QuoteOptInDiscountOutput } from '../../entities/QuoteOptInDiscountOutput';
import { FormFileUpload } from '@ami/react/core';
import { Button } from 'reactstrap';
import { Spinner } from '@ami/react/core';
import { apiFetch } from '@ami/react/core';

export default class ReviewQuoteOptInDiscountsListItem extends React.Component {
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    discount: PropTypes.instanceOf(QuoteOptInDiscountOutput).isRequired,
    onToggleDiscount: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.isCheckedDiscount = this.isCheckedDiscount.bind(this);

    this.state = {
      downloading: false,
      originalFileKey: null,
    };
  }

  componentDidMount() {
    const quoteDiscount = this.getDiscountQuote();
    if (quoteDiscount) {
      this.setState({ originalFileKey: quoteDiscount.documentationFileKey });
    }
  }

  isCheckedDiscount() {
    const { quote, discount } = this.props;
    const quoteDiscount = quote.optInDiscounts.find((x) => x.discountId === discount.id);
    return !!quoteDiscount;
  }

  getDiscountQuote() {
    const { quote, discount } = this.props;
    const discounts = quote.optInDiscounts;
    return discounts.find((x) => x.discountId === discount.id);
  }

  downloadDocument = async () => {
    const { quote, discount } = this.props;
    this.setState({ downloading: true });
    const response = await apiFetch(
      `quotes/${quote.id}/discount-documentation/${discount.id}`
    );
    window.location = response.url;
    this.setState({ downloading: false });
  };

  render() {
    const { discount, onToggleDiscount } = this.props;
    const { originalFileKey } = this.state;
    const discountQuote = this.getDiscountQuote();
    const isCheckedDiscount = this.isCheckedDiscount();

    return (
      <div className="col-md-4">
        <div className="question mb-2">
          <FormToggle
            checked={isCheckedDiscount}
            label={discount.name}
            disabled={false}
            onChange={(checked) =>
              onToggleDiscount(checked, discount.id, '', '')
            }
          />
        </div>
        {discount.supportingDocumentsRequired && isCheckedDiscount && (
          <Fragment>
            {discountQuote &&
              discountQuote.documentationFileKey &&
              discountQuote.documentationFileKey === originalFileKey && (
                <div className="document mb-2">
                  <Button
                    color="outline-primary"
                    className="btn-sm"
                    onClick={() => this.downloadDocument()}
                  >
                    {this.state.downloading && <span>Downloading...</span>}
                    {!this.state.downloading && (
                      <span>
                        Download Document <span className="fa fa-download" />
                      </span>
                    )}
                    <Spinner show={this.state.downloading} />
                  </Button>
                  <button
                    className="btn btn-sm btn-danger m-1"
                    type="button"
                    onClick={() => onToggleDiscount(true, discount.id, '', '')}
                  >
                    Remove Document
                  </button>
                </div>
              )}
            {!(
              discountQuote &&
              discountQuote.documentationFileKey &&
              discountQuote.documentationFileKey === originalFileKey
            ) && (
              <div className="document">
                <FormFileUpload
                  label={discount && discount.supportingDocumentsPromptText}
                  hideUploadAfterFile={true}
                  onFileUploaded={(fileInfo) =>
                    onToggleDiscount(
                      true,
                      discount.id,
                      fileInfo.key,
                      fileInfo.name
                    )
                  }
                >
                  {discountQuote && discountQuote.documentationFileName}
                </FormFileUpload>
              </div>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}
